import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locale/en'
import de from './locale/de'
import it from './locale/it'

const resources = {
  en,
  de,
  it,
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    lng: 'en',
  })

export default i18n
